/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UpdateTenantLogoDefaultRequest } from '../../models/update-tenant-logo-default-request';

export interface UpdateTenantLogoDefault$Params {

/**
 * Id of a resource.
 */
  id: string;
      body: UpdateTenantLogoDefaultRequest
}

export function updateTenantLogoDefault(http: HttpClient, rootUrl: string, params: UpdateTenantLogoDefault$Params, context?: HttpContext): Observable<StrictHttpResponse<any>> {
  const rb = new RequestBuilder(rootUrl, updateTenantLogoDefault.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {"style":"simple","explode":false});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<any>;
    })
  );
}

updateTenantLogoDefault.PATH = '/api/v1/tenants/{id}/logos';
